import { MainNavSection } from '../../../models/mainnav';
import { menuItem_FAQ } from '../MenuItems/MenuItems';

export const Default_Menu: MainNavSection[] = [
  {
    label: 'INFORMATION',
    navItems: [menuItem_FAQ],
  },
];
